/* eslint-disable no-console  -- log error from balance fetch */
"use client";

import { useQuery } from "@tanstack/react-query";
import { type Address, erc20Abi } from "viem";

import { nativeTokenAddress } from "#/config/web3/nativeTokenAddress";
import { isEqualAddress } from "#/utils/isEqualAddress";

import { readContract } from "./blockchain.service";

export const useReadTokenBalance = (
  account?: Address,
  tokenAddress?: Address,
  chainId?: number | string,
) => {
  const isNativeToken = isEqualAddress(tokenAddress, nativeTokenAddress);

  const {
    data = 0n,
    error,
    isLoading,
    isFetching,
    ...rest
  } = useQuery({
    queryKey: ["readContract", "balanceOf", account, tokenAddress, chainId],
    queryFn: () => {
      return readContract(
        {
          abi: erc20Abi,
          args: [account!],
          address: tokenAddress!,
          functionName: "balanceOf",
        },
        chainId,
      );
    },
    enabled: Boolean(account) && Boolean(tokenAddress) && !isNativeToken,
    retry: 3,
  });

  if (error) {
    console.log("Error reading tokenBalance:", error);
  }

  return {
    ...rest,
    data: BigInt(data),
    isLoading: isLoading || isFetching,
  };
};
